<template>    
    <div>
        <b-modal ref="showModal" size="lg" hide-footer no-close-on-backdrop title="Actualizar tiempos de la Unidad">
            <b-form @submit.prevent="guardar">
                <b-form-group label="Fecha de inicio de operación">
                    <b-form-input type="datetime-local" v-model="unidad.fecha_inicio_operacion" required></b-form-input>
                </b-form-group>
                <b-form-group label="Tiempo acumulado de operación (En segundos)">
                    <b-form-input type="number" v-model="unidad.acumulado_operacion" required></b-form-input>
                </b-form-group>
                <b-form-group label="Fecha de último mantenimiento">
                    <b-form-input type="datetime-local" v-model="unidad.fecha_ultimo_mantenimiento" required></b-form-input>
                </b-form-group>
                <b-form-group label="Tiempo acumulado de mantenimiento (En segundos)">
                    <b-form-input type="number" v-model="unidad.acumulado_mantenimiento" required></b-form-input>
                </b-form-group>
                <b-button type="submit" variant="primary">Actualizar</b-button>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
    import axios from 'axios';
    import Swal from 'sweetalert2';

    export default {
        data() {
            return {
                unidad: {fecha_inicio_operacion: null, acumulado_operacion: 0, fecha_ultimo_mantenimiento: null, acumulado_mantenimiento: 0},
            }
        },
        methods: {
            verModal(unidad) {
                // console.log(unidad)
                // Aquí puedes cargar los datos de la unidad si es necesario
                if(unidad.tiemposdeoperacione){
                    this.unidad = {...unidad.tiemposdeoperacione};
                    this.$refs['showModal'].show();
                    return
                }
                this.unidad.fecha_inicio_operacion = unidad.fecha_adquisicion;
                this.unidad.acumulado_operacion = 0;
                this.unidad.fecha_ultimo_mantenimiento = unidad.fecha_adquisicion;
                this.unidad.acumulado_mantenimiento = 0;
                this.$refs['showModal'].show();
            },
            guardar() {
                // lógica para guardar los datos
                axios.put(`/api/update-tiempo-operacion/${this.unidad.cbi}`, this.unidad, {
                    headers: {"Authorization": `Bearer ${this.$store.state.user.token}`}
                })
                .then(() => {
                    this.$refs['showModal'].hide();
                    Swal.fire({
                        icon: 'success',
                        title: '¡Actualizado!',
                        text: 'Se actualizaron los tiempos de operación correctamente.',
                        confirmButtonText: 'Aceptar'
                    }).then(() => {
                        window.location.reload(); // Refresca la página
                    });

                })
                .catch(err => {
                    console.error(err);
                });
            }
        }
    }
</script>